import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const Navigation = () => {
  const location = useLocation();
  const pathname = location.pathname.split("/").filter((x) => x);

  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/inicio" }}>
          inicio
        </Breadcrumb.Item>
        {pathname.length >= 1 &&
          (pathname[0] !== "inicio") ?
            pathname.map((value, index) => {
              const to = `${pathname.slice(0, index + 1).join("/")}`;
              return (
                <Breadcrumb.Item key={to} linkAs={Link} linkProps={{ to }}>
                  {value}
                </Breadcrumb.Item>
              );
            }) : <></>}
      </Breadcrumb>
    </>
  );
};

export default Navigation;
